export default "__VITE_ASSET__CGSCNgSo__"